define(['./util/each.js', './util/is-equal.js', './util/is-string.js', './util/is-function.js'], function(each, isEqual, isString, isFunction) {
    var tokens, tokenChangedListeners;

    reset();

    return {
        getToken: getToken,
        setToken: setToken,
        onTokenChanged: onTokenChanged,
        reset: reset
    };

    function getToken(key) {
        if (!key || !isString(key)) {
            throw new Error('getToken expects a string key');
        }

        return tokens[key];
    }

    function setToken(key, value) {
        if (!key || !isString(key)) {
            throw new Error('setToken expects a string key');
        }

        if (isEqual(tokens[key], value)) {
            return;
        }

        tokens[key] = value;
        each(tokenChangedListeners[key] || [], function iterateTokenChangedListeners(callback) {
            callback(tokens[key]);
        });
    }

    function onTokenChanged(key, callback) {
        if (!key || !isString(key)) {
            throw new Error('onTokenChanged expects a string key');
        }

        if (!isFunction(callback)) {
            throw new Error('onTokenChanged expects a callback of type function');
        }

        if (!tokenChangedListeners[key]) {
            tokenChangedListeners[key] = [];
        }

        tokenChangedListeners[key].push(callback);

        return function off() {
            tokenChangedListeners[key].splice(tokenChangedListeners[key].indexOf(callback), 1);
        };
    }

    function reset() {
        tokens = {};
        tokenChangedListeners = {};
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/context.js
 ** module id = 124
 ** module chunks = 0
 **/